import { Box, Flex, Skeleton, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
import { makeMed2, makeReg4 } from '../../../styles/textStyles';
const EpcChartBars = ({ bands, barHeight, children, isLoading, smallestWidth, widthIncrement, }) => {
    const tokens = useTokens();
    return (React.createElement(Box, { "data-testid": "epc_chart_bars", position: "relative" },
        React.createElement(VStack, { align: "stretch", gap: tokens.Spacing01, position: "relative" }, bands.map(({ range, label, color, variant }, i) => {
            const textColor = variant === 'white' ? tokens.TextWhite100 : tokens.TextBlack800;
            return (React.createElement(Skeleton, { w: `${smallestWidth + widthIncrement * i}%`, isLoaded: !isLoading, key: label, height: barHeight },
                React.createElement(Flex, { "data-testid": "epc_chart_bars__bar", bg: color, h: barHeight, align: "center", px: tokens.Spacing03, position: "relative" },
                    React.createElement(Text, { "data-testid": "epc_chart_bars__range", flex: "1", sx: makeReg4(tokens, { color: textColor }) }, `${range[0]} - ${range[1]}`),
                    React.createElement(Text, { "data-testid": "epc_chart_bars__label", sx: makeMed2(tokens, { color: textColor }) }, label))));
        })),
        children));
};
export default EpcChartBars;
